export enum WalletsQueryKeys {
  Me = '/wallets/me',
}
